import VideoViewer from './video-viewer';
import { VIDEO_TYPE_LEGACY, VIDEO_TYPE } from './types';
import { containerClassName, sizeClassName } from './classNameStrategies';
import videoComponentWrapper from './components/VideoComponentWrapper/video-component-wrapper';
var videoRenderDescriptor = function (externalVideoComponent) { return ({
    component: externalVideoComponent
        ? videoComponentWrapper(externalVideoComponent)
        : VideoViewer,
    classNameStrategies: {
        size: sizeClassName,
        container: containerClassName,
    },
}); };
export function typeMapper(externalVideoComponent) {
    return function () {
        var _a;
        return (_a = {},
            _a[VIDEO_TYPE_LEGACY] = videoRenderDescriptor(externalVideoComponent),
            _a[VIDEO_TYPE] = videoRenderDescriptor(externalVideoComponent),
            _a);
    };
}
//# sourceMappingURL=typeMapper.js.map